import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { TbEditCircle } from "react-icons/tb";
import { useNavigate, useParams } from "react-router";
import Deletepopup from "../../components/Modal/Deletepopup";
import FaqBanner from "./FaqBanner";
import scroll from "../../assets/webp/scroll.webp";

const FaqSectionsQuestionsAndAnswer = () => {
  const [faqQuestionsAndAnswer, setFaqQuestionsAndAnswer] = useState([]);
  const [isdelete, setIsdelete] = useState({ modal: false, id: "" });

  const [loader, setLoader] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getFaqquestionAndAnswers();
  }, [id]);

  const getFaqquestionAndAnswers = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}faq/list`, { section: id })
      .then((response) => {
        setFaqQuestionsAndAnswer(response?.data?.rows);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_API_URL}faq/delete/${id}`, {
      method: "DELETE",
    }).then((result) => {
      result.json().then((res) => {
        getFaqquestionAndAnswers();
        setIsdelete({ modal: false, id: "" });
      });
    });
  };

  useEffect(() => {
    faqQuestionsAndAnswer.length > 0 && setTimeout(() => setLoader(false));
  }, [faqQuestionsAndAnswer]);

  return (
    <>
      <FaqBanner />

      <div className="">
        {!loader ? (
          <>
            {faqQuestionsAndAnswer.length ? (
              <div className="faq-scrollable">
                {faqQuestionsAndAnswer.map((data, idx) => {
                  return (
                    <Fragment key={idx}>
                      <div className="p-2 questionWrapper d-flex">
                        <div className="questionContent">
                          Q. {data?.question}
                        </div>
                        <div className="iconWrapper">
                          <div className="editIcon cursor-pointer">
                            <TbEditCircle
                              onClick={() =>
                                navigate(`/faq/${data._id}/edit-faq`)
                              }
                            />
                          </div>
                          <div className="deleteIcon cursor-pointer">
                            <RiDeleteBin6Line
                              onClick={() =>
                                setIsdelete({ modal: true, id: data._id })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-3 mb-4 p-2 answerWrapper">
                        A. {data?.answer}
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            ) : (
              <div className="mt-4">No questions and Answers</div>
            )}
          </>
        ) : (
          <div className="d-flex justify-content-center">
            <img src={scroll} width={150} alt="loader" />
          </div>
        )}

        {isdelete.modal && (
          <Deletepopup handleDelete={handleDelete} id={isdelete?.id} />
        )}
      </div>
    </>
  );
};
export default FaqSectionsQuestionsAndAnswer;
